import { createSelector } from 'reselect';
import { EXCLUDED_TYPES } from 'utils/globalConst';
import { ContratEpargnInfo } from './types';

export const selectIntl = (state: any) => state.intl;

export const getContractTypeState = (state: any) =>
  state.getIn(['contract', 'contractsType']);
const getIsLoadingContract = (state: any) =>
  state.getIn(['contract', 'isLoadingContract']);

export const getContractsAuto = (state: any) =>
  state.getIn(['contract', 'contractsAuto']);

const getKey1 = (state: any) => state.getIn(['contract', 'key1']);
const getKey2 = (state: any) => state.getIn(['contract', 'key2']);
const getKey3 = (state: any) => state.getIn(['contract', 'key3']);

const getAuthContratEpargn = (state: any): ContratEpargnInfo =>
  state.getIn(['contract', 'authContratEpargn']);

const getTypeContractInfo = (state: any) => state.getIn(['contract', 'type']);
const getnumPolice = (state: any) => state.getIn(['contract', 'numPolice']);
const getDateEcheance = (state: any) =>
  state.getIn(['contract', 'dateEcheance']);

const getTypeContract = (state: any) =>
  state.getIn(['contract', 'typeContract']);

const getDetailContract = (state: any) =>
  state.getIn(['contract', 'detailContract']);
const getIsLoadingContractEpargn = (state: any) =>
  state.getIn(['contract', 'isLoadingContractEpargn']);

const getIsLoadingDetailContract = (state: any) =>
  state.getIn(['contract', 'isLoadingContractDetail']);

const getFilesContractAuto = (state: any) => state.getIn(['contract', 'files']);

const getServicesContractAuto = (state: any) =>
  state.getIn(['contract', 'servicesAssitance']);

const getGarantiesContractAuto = (state: any) =>
  state.getIn(['contract', 'garantiesAuto']);

const getContractsMrh = (state: any) =>
  state.getIn(['contract', 'contractsMRH']);
const getOpenModalSuccess = (state: any) =>
  state.getIn(['contract', 'openModalSucces']);

const getIsOpenAddNewContractModal = (state: any) =>
  state.getIn(['contract', 'isOpenAddNewContractModal']);
const getDetailsContractMrh = (state: any) =>
  state.getIn(['contract', 'detailContractMRH']);
const getIsLoadingContractDetailsMrh = (state: any) =>
  state.getIn(['contract', 'isLoadingGetDetailsMrh']);
const getMrhGaranties = (state: any) =>
  state.getIn(['contract', 'garantiesMrh']);
const getMrhFiles = (state: any) => state.getIn(['contract', 'filesMrh']);
const getContractsEpargn = (state: any) =>
  state.getIn(['contract', 'contractsEpargn']);
const getProduct = (state: any) => state.getIn(['contract', 'product']);
const getIsloadingProduct = (state: any) =>
  state.getIn(['contract', 'isLoadingProduct']);

const getIsloadingProductSelector = createSelector(
  getIsloadingProduct,
  (isloadingProduct) => isloadingProduct,
);
const getProductSelector = createSelector(getProduct, (product) => product);
const getIsLoadingContractSelector = createSelector(
  getIsLoadingContract,
  (isLoadingContract) => isLoadingContract,
);
const getDetailsContractMrhSelector = createSelector(
  getDetailsContractMrh,
  (detailsContractsMrh) => detailsContractsMrh,
);
const getIsLoadingContractDetailsMrhSelector = createSelector(
  getIsLoadingContractDetailsMrh,
  (isLoadingGetDetailsMrh) => isLoadingGetDetailsMrh,
);
const getMrhGarantiesSelector = createSelector(
  getMrhGaranties,
  (mrhGaranties) => mrhGaranties,
);
const getMrhFilesSelector = createSelector(getMrhFiles, (filesMrh) => filesMrh);

const getContractTypeSelector = createSelector(
  getContractTypeState,
  (contractsType) =>
    (contractsType || []).filter(
      (contract: any) => !EXCLUDED_TYPES.includes(contract.type),
    ),
);

const getTypeContractSelector = createSelector(
  getTypeContract,
  (contractType) => contractType,
);
const getContractAutoSelector = createSelector(
  getContractsAuto,
  (contractsAuto) => contractsAuto,
);

const getKey1Selector = createSelector(getKey1, (Key1) => Key1);

const getKey2Selector = createSelector(getKey2, (Key2) => Key2);

const getKey3Selector = createSelector(getKey3, (Key3) => Key3);

const getTypeContractInfoSelector = createSelector(
  getTypeContractInfo,
  (typeContractInfo) => typeContractInfo,
);
const getDetailsContractSelector = createSelector(
  getDetailContract,
  (detailContract) => {
    return detailContract;
  },
);

const getFilesContractAutoSelector = createSelector(
  getFilesContractAuto,
  (files) => files,
);
const getGrantiesContractAutoSelector = createSelector(
  getGarantiesContractAuto,
  (garanties) => garanties,
);

const getIsLoadingDetailContractSelector = createSelector(
  getIsLoadingDetailContract,
  (isLoadingDetailContract) => isLoadingDetailContract,
);
const getNumPoliceSelector = createSelector(
  getnumPolice,
  (numPolice) => numPolice,
);
const getDateEcheanceSelector = createSelector(
  getDateEcheance,
  (dateEcheance) => dateEcheance,
);
const getServicesContractAutoSelector = createSelector(
  getServicesContractAuto,
  (servicesAssitance) => servicesAssitance,
);
const getContractsMrhSelector = createSelector(
  getContractsMrh,
  (contractsMrh) => contractsMrh,
);
const getOpenModalSuccessSelector = createSelector(
  getOpenModalSuccess,
  (openModalSuccess) => openModalSuccess,
);
const getIsOpenAddNewContractModalSelector = createSelector(
  getIsOpenAddNewContractModal,
  (isOpenAddNewContractModal) => isOpenAddNewContractModal,
);
const getContractsEpargnSelector = createSelector(
  getContractsEpargn,
  (contractsEpargn) => contractsEpargn.toJS(),
);
const getSituationEpargne = createSelector(getContractsEpargn, (epargnes) => {
  if (epargnes.length > 0) {
    return epargnes[0];
  }
});
const getIsLoadingContractEpargnSelector = createSelector(
  getIsLoadingContractEpargn,
  (isLoadingContractEpargn) => isLoadingContractEpargn,
);

export const getContractsAMC = (state: any) =>
  state.getIn(['contract', 'contractsAMC']);

const getContractAMCSelector = createSelector(getContractsAMC, (contractsAMC) =>
  contractsAMC.toJS(),
);

const getBeneficiaries = (state: any) =>
  state.getIn(['contract', 'beneficiaries']);

const getBeneficiariesSelector = createSelector(
  getBeneficiaries,
  (beneficiaries) => beneficiaries.toJS(),
);

export const getContractsASI = (state: any) =>
  state.getIn(['contract', 'contractsASI']);

const getContractASISelector = createSelector(getContractsASI, (contractsASI) =>
  contractsASI.toJS(),
);

export const getContractAMCDetails = (state: any) =>
  state.getIn(['contract', 'contractsAMCDetail']);

const getContractAMCDetailsSelector = createSelector(
  getContractAMCDetails,
  (details) => details.toJS(),
);

export {
  getContractTypeSelector,
  getIsLoadingContractSelector,
  getTypeContractSelector,
  getKey2Selector,
  getKey3Selector,
  getKey1Selector,
  getContractAutoSelector,
  getTypeContractInfoSelector,
  getNumPoliceSelector,
  getDateEcheanceSelector,
  getDetailsContractSelector,
  getIsLoadingDetailContractSelector,
  getFilesContractAutoSelector,
  getServicesContractAutoSelector,
  getGrantiesContractAutoSelector,
  getContractsMrhSelector,
  getOpenModalSuccessSelector,
  getIsOpenAddNewContractModalSelector,
  getIsLoadingContractDetailsMrhSelector,
  getDetailsContractMrhSelector,
  getMrhGarantiesSelector,
  getMrhFilesSelector,
  getContractsEpargnSelector,
  getSituationEpargne,
  getIsloadingProductSelector,
  getProductSelector,
  getAuthContratEpargn,
  getIsLoadingContractEpargnSelector,
  getContractAMCSelector,
  getBeneficiariesSelector,
  getContractASISelector,
  getContractAMCDetailsSelector,
};
